/*---

  Scripts for the slideshow

  Louis-Charles Blais [info@22agencecreative.ca]

---*/


function showSlide(slideshow, index) {
  const slides = slideshow.querySelectorAll('.slide');
  const slideSelectors = slideshow.querySelectorAll('.slide-selector');
  const count = slides.length;
  if (count === 0) return;

  index = (index + count) % count;

  for (let i = 0; i < count; i++) {
    slides[i].classList.remove('active');
    if (slideSelectors[i]) slideSelectors[i].classList.remove('active');
  }

  slides[index].classList.add('active');
  if (slideSelectors[index]) slideSelectors[index].classList.add('active');

  slideshow._currentSlide = index;
}

function goToSlide(target, index) {
  const slideshow = target.closest('.slideshow-container');
  showSlide(slideshow, index);
  restartAutoplay(slideshow);
}

function startAutoplay(slideshow) {
  const interval = parseInt(slideshow.dataset.autoplayInterval, 10);
  const slideCount = slideshow.querySelectorAll('.slide').length;
  if (!interval || interval <= 0 || slideCount < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  slideshow._autoplayTimer = setInterval(function () {
    showSlide(slideshow, (slideshow._currentSlide || 0) + 1);
  }, interval);
}

function stopAutoplay(slideshow) {
  if (slideshow._autoplayTimer) {
    clearInterval(slideshow._autoplayTimer);
    slideshow._autoplayTimer = null;
  }
}

function restartAutoplay(slideshow) {
  stopAutoplay(slideshow);
  startAutoplay(slideshow);
}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.slideshow-container').forEach(function (slideshow) {
    slideshow._currentSlide = 0;
    slideshow.addEventListener('mouseenter', function () { stopAutoplay(slideshow); });
    slideshow.addEventListener('mouseleave', function () { startAutoplay(slideshow); });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stopAutoplay(slideshow); } else { startAutoplay(slideshow); }
    });
    startAutoplay(slideshow);
  });
});
